<template>
    <div class="header-search ">
        <div class="p-2 p-md-3 d-flex justify-content-center align-items-center bg-color-white box-shadow-large">
            <i class="mx-3 fas fa-fw fa-search font-size-h4"></i>

            <input type="search"
                   class="main-search-field"
                   :name="inputName"
                   :placeholder="inputPlaceholder"
                   required
                   v-model="searchValue"
                   @input="searchValueChanged">

            <i class="fas fa-times cursor-pointer" v-show="searchValue.length" @click="emptyInput"></i>

        </div>

        <div class="search-result position-absolute w-100 box-shadow-large grey-bg py-4" style="overflow-y: scroll; max-height: 80vh;"  v-if="searchValue.length">

            <div class="row position-relative z-index-1 container m-0 ">
                <div class="col-12">
                    <div v-if="loading" class="text-center font-size-large">
                        <i class="far fa-spinner-third fa-spin cards-spinner-icon"></i>
                    </div>
                </div>
                <div class="col-12" v-if="!loading && !cinemas.length && !movies.length">
                    <p class="text-center">Geen resultaten voor '{{searchValue}}' </p>
                </div>
                <div class="col-12" v-if="!loading && cinemas.length">
                    <h3>Bioscopen</h3>
                </div>
                <div class="col-12 search-item bg-white" v-for="(cinema, index) in cinemas" v-if="!loading && cinemas.length">
                    <div class="row" v-bind:class="{'pt-4': index === 0, 'pb-4': index+1 === cinemas.length}" >
                        <div class="col-10 col-lg-9">
                            <h4 class="mb-0">
                                <a :href="cinema.singleUrl">
                                    {{ cinema.name }}
                                </a>
                            </h4>

                            <small>{{cinema.fullAddress}}</small>

                            <div class="mt-3 movie-card-buttons">
                                <a class="mt-sm-0 btn btn-secondary size-small" :href="cinema.singleUrl">
                                    Meer info
                                </a>

                                <a class="mt-sm-3 mt-md-0 btn btn-secondary size-small" target="_blank" :href="'https://maps.google.com/?q=' + cinema.name">
                                    Route
                                </a>
                            </div>
                        </div>
                        <div class="col-12">
                            <hr class="my-4 page-filter-separator"  v-if="index+1 !== cinemas.length" />
                        </div>
                    </div>
                </div>
                <div class="col-12" v-bind:class="{'mt-4': cinemas.length}" v-if="!loading && movies.length">
                    <h3>Films</h3>
                </div>

                <div class="col-12 search-item bg-white" v-for="(movie, index) in movies" v-if="!loading && movies.length">

                    <div class="row" v-bind:class="{'pt-4': index === 0, 'pb-4': index+1 === cinemas.length}">
                        <a class="col-2 col-lg-1 movie-card-poster" :href="movie.singleUrl">
                            <img class="img-fluid" :src="movie.poster || this.defaultPoster" :alt="movie.title">
                        </a>

                        <div class="col-10 col-lg-9">
                            <h4 class="mb-0 d-inline-block">
                                <a :href="movie.singleUrl">
                                    {{ movie.title }}
                                </a>
                            </h4>
                            <small class="color-grey--dark" v-if="movie.releaseYear">
                                ({{ movie.releaseYear}})
                            </small>

                            <div>
                                <small>{{movie.oneliner}}</small>
                            </div>

                            <div class="mt-3 movie-card-buttons">
                                <a class="mt-sm-0 btn btn-secondary size-small" :href="movie.singleUrl">
                                    Meer info
                                </a>

                                <a class="mt-sm-3 mt-md-0 btn btn-secondary size-small" :href="movie.singleUrl+'#filmagenda'">
                                    Filmtijden
                                </a>
                            </div>
                        </div>
                        <div class="col-12" v-if="index+1 !== movies.length">
                            <hr class="my-4 page-filter-separator" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import SearchByFilters from '../MrMovie/SearchByFilters';
    import MovieCards from "./movies/MovieCards";

    export default {
        components: {MovieCards},
        props: {
            // 'movie_cinema', 'movie', or 'cinema'
            searchType: {
                type: String,
                required: true,
            },
            inputName: {
                type: String,
                default: 'movie_cinema_search',
            },
            inputValue: {
                type: String,
                default: null,
            },
            inputPlaceholder: {
                type: String,
                default: 'Zoek naar film, serie of bioscoop',
            }
        },
        data() {
            return {
                searchValue: this.inputValue,
                cinemaSearchByFilters: null,
                movies: [],
                cinemas: [],
                defaultPoster: MrMovie.defaults.imagePaths.movieSmall,
                searchByFilters: new SearchByFilters(this.eventName, '/ajax/search'),
                timer: null
            };
        },
        mounted() {

        },
        methods: {
            /**
             * Emit the search value as a filter for searching
             * @return {void}
             */
            searchValueChanged() {

                clearTimeout(this.timer);
                let self = this;
                this.loading = true;
                this.timer = setTimeout(function() {
                        self.searchByFilters.doRequest({'title': self.searchValue}, false).then(response => {
                            self.movies = [];
                            self.cinemas = [];
                            self.loading = false;
                            if(typeof response.movies !== 'undefined' && typeof response.movies.items !== 'undefined' && response.movies.items.length) {
                                // Improve / expand movie data

                                self.movies = response.movies.items.map(movie => {
                                    // Define the movie poster and trailer URLs
                                    movie.poster = MrMovie.mediaHelper.makeImageUrl(movie.poster, 'card');
                                    movie.trailer = MrMovie.mediaHelper.makeVideoUrl(movie.trailer, 'desktop');

                                    if(!movie.poster) {
                                        movie.poster = self.defaultPoster;
                                    }
                                    return movie;
                                });
                            }

                            if(typeof response.cinemas !== 'undefined' && typeof response.cinemas.items !== 'undefined' && response.cinemas.items.length) {
                                // Improve / expand movie data
                                self.cinemas = response.cinemas.items;
                            }
                        }, self).catch(function (error) {
                            self.loading = false;
                        });
                    },
                    400   // Guestimate the best value you want, usually I use 300 - 400 ms
                )


            },

            emptyInput() {
                this.searchValue = '';
            },

            /**
             * Hide the filter buttons, when the modal is open
             * @param bvEvt
             */
            modalShow: bvEvt => {
                $('.hide-during-trailer-modal').addClass('d-none');
            },
            /**
             * Show the filter buttons again, when the modal is closed
             * @param bvEvt
             */
            modalHide: bvEvt => {
                $('.hide-during-trailer-modal').removeClass('d-none');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/HeaderSearch.vue